import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { ErrorAlertMessage } from '../MachineDetailsRobotLiveMapScreen/MachineDetailsRobotLiveMapScreen.styles';
import { RobotCleaningControlActions } from 'app/modules/machine-inventory/machine-details-panel/state/machineDetailsPanelRobot/robotCleaningControl/robotCleaningControlSlice';
import { selectRobotCleaningControlErrorCommandType } from 'app/modules/machine-inventory/machine-details-panel/state/machineDetailsPanelRobot/robotCleaningControl/robotCleaningControlSelectors';
import { CLEANING_COMMAND_TYPE_TO_ACTION_KEY } from 'app/modules/machine-inventory/machine-details-panel/state/machineDetailsPanelRobot/robotCleaningControl/utils/constants';
import type { BRangeCleaningCommandType } from 'app/cross-cutting-concerns/communication/interfaces/pra-api-graphql';

interface CleaningCommandErrorAlertProps {
  /** The alert shows only when the failed command is one of these. */
  commandTypes: BRangeCleaningCommandType[];
  /** Shows the ✕ that dismisses the alert (default). Modals pass false and dismiss on close instead. */
  isClosable?: boolean;
}

export const CleaningCommandErrorAlert = ({
  commandTypes,
  isClosable = true,
}: CleaningCommandErrorAlertProps): JSX.Element | null => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const errorCommandType = useSelector(selectRobotCleaningControlErrorCommandType);

  if (!errorCommandType || !commandTypes.includes(errorCommandType)) {
    return null;
  }

  const actionKey = CLEANING_COMMAND_TYPE_TO_ACTION_KEY[errorCommandType];

  return (
    <ErrorAlertMessage
      $isClosable={isClosable}
      message={t(`robotCleaningControl.${actionKey}.alert`)}
      afterClose={(): void => {
        dispatch(RobotCleaningControlActions.dismissCleaningCommandError());
      }}
    />
  );
};
